export default "__VITE_ASSET__a7b21e8d__"